type Layer = any;

export class LayerService {
    private layers: Layer[];
    private viewer: any;

    constructor() {
        this.layers = [];
        this.viewer = window.viewer;
    }

    addLayer(layer: Layer) {
        if (!layer.uuid) {
            let uuid = PSPCustomization.pspUtils.GetNewGuid();
            layer.uuid = uuid;
        }
        const defcolorPoint = { r: 255, g: 0, b: 0, a: 0.0 };
        layer.colorPoint = layer.colorPoint
            ? layer.colorPoint
            : layer.datalayers &&
              layer.datalayers[0] &&
              layer.datalayers[0].colorPoint
            ? layer.datalayers[0].colorPoint
            : defcolorPoint;

        this.layers.push(layer);
        this.viewer.scene.dispatchEvent({
            type: 'layer_added',
            scene: this,
            layer: layer,
        });
    }

    removeLayer(layerId: string) {
        let index = this.layers.findIndex((layer) => layer.uuid === layerId);
        if (index > -1) {
            let layer = this.layers[index];
            this.layers.splice(index, 1);
            this.viewer.scene.dispatchEvent({
                type: 'layer_removed',
                scene: this,
                layer: layer,
            });
        }
    }

    getLayers() {
        return this.layers;
    }
}
